import { get, post } from '../Services/http';
import { catchError } from './Error.action';

export const BANKID_AUTHENTICATE = 'BANKID_AUTHENTICATE';
export const BANKID_COLLECT = 'BANKID_COLLECT';
export const BANKID_ERROR = 'BANKID_ERROR';

export const loadError = error => ({
    type: BANKID_ERROR,
    payload: {
        error,
    }
})

export const receive = bankId => ({
    type: BANKID_AUTHENTICATE,
    payload: bankId,
})
const collect = status => ({
    type: BANKID_COLLECT,
    payload: status
})

export const authenticate = (ssn) => {
    return (dispatch) => {
        if (!ssn || ssn.length === 0) {
            return;
        }

        return get('/api/bankid/auth?ssn='+ ssn)
            .then(response => response.json())
            .catch(ex => dispatch(catchError(ex, error => loadError(error))))
            ;
    }
}

export const getStatus = () => {
    return get('/api/bankid/collect')
        .then(response => response.json())
        .then(statusInfo => {
            dispatch(collect(statusInfo));
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

